import { Popover, PopoverTrigger, PopoverContent } from '@you/ui'
import { cn, generateAvatarColors, getNameInitial } from '@/lib/utils'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'
import { useNavigate } from 'react-router-dom'
import { useLogout } from '@/api/hooks/useUser'

export function NavUser({
  user,
}: {
  user: {
    name: string
    email: string
    avatar: string
  }
}) {
  const navigate = useNavigate()
  const { trigger: logout, isMutating: isLoggingOut } = useLogout()
  const avatarColors = generateAvatarColors(user.name)

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/login')
    } catch (error) {
      console.error('Logout failed:', error)
      // 即使API调用失败，也跳转到登录页
      navigate('/login')
    }
  }

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <Popover>
          <PopoverTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className={cn(
                'data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground',
                'group-data-[collapsible=icon]:h-12'
              )}
            >
              <Avatar className="h-8 w-8 rounded-full">
                <AvatarImage src={user.avatar} alt={user.name} />
                <AvatarFallback
                  className="rounded-full"
                  style={{
                    backgroundColor: avatarColors.bg,
                    color: avatarColors.text,
                    fontSize: '16px',
                    fontWeight: 500,
                  }}
                >
                  {getNameInitial(user.name)}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
                <span className="truncate font-semibold">{user.name}</span>
                <span className="truncate text-xs">{user.email}</span>
              </div>
            </SidebarMenuButton>
          </PopoverTrigger>
          <PopoverContent side="top" className="w-[194px] p-0">
            <ul className="text-lg text-[#333333] text-center py-1 [&>li]:leading-[48px] [&>li:hover]:bg-[#8752FF1A] [&>li]:cursor-pointer">
              <li>账号设置</li>
              <li
                onClick={handleLogout}
                className={isLoggingOut ? 'opacity-50 cursor-not-allowed' : ''}
              >
                {isLoggingOut ? '退出中...' : '退出登录'}
              </li>
            </ul>
          </PopoverContent>
        </Popover>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
